(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/http"), require("rxjs/Rx"), require("rxjs/operator/map"), require("@angular/common"), require("rxjs/operator/filter"), require("rxjs/operator/catch"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/http", "rxjs/Rx", "rxjs/operator/map", "@angular/common", "rxjs/operator/filter", "rxjs/operator/catch"], factory);
	else if(typeof exports === 'object')
		exports["ngxKeycloak"] = factory(require("@angular/core"), require("@angular/http"), require("rxjs/Rx"), require("rxjs/operator/map"), require("@angular/common"), require("rxjs/operator/filter"), require("rxjs/operator/catch"));
	else
		root["ngxKeycloak"] = factory(root["ng"]["core"], root["ng"]["http"], root["Rx"], root["Rx"]["Observable"]["prototype"], root["ng"]["common"], root["Rx"]["Observable"]["prototype"], root["Rx"]["Observable"]["prototype"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_25__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(6);
var http_1 = __webpack_require__(2);
var keycloak_adapter_default_1 = __webpack_require__(7);
var Rx_1 = __webpack_require__(3);
__webpack_require__(4);
var keycloak_adapter_cordova_1 = __webpack_require__(8);
var keycloak_storage_local_1 = __webpack_require__(9);
var keycloak_storage_cookie_1 = __webpack_require__(10);
var keycloak_utils_URIParser_1 = __webpack_require__(11);
var keycloak_utils_loginIframe_1 = __webpack_require__(12);
var keycloak_utils_token_1 = __webpack_require__(13);
var keycloak_utils_singleton_1 = __webpack_require__(14);
var angular2_uuid_1 = __webpack_require__(19);
var keycloak_storage_ionic_1 = __webpack_require__(15);
var Keycloak = (function () {
    // public constructor
    function Keycloak(ionicStorageService, platformId) {
        this.ionicStorageService = ionicStorageService;
        this.platformId = platformId;
        this.lock = keycloak_utils_singleton_1.Lock.getInstance();
        this.loginIframe = new keycloak_utils_loginIframe_1.LoginIframe(true, [], 5);
    }
    Keycloak_1 = Keycloak;
    // Keycloak methods
    Keycloak.prototype.login = function (options) {
        return this.adapter.login(options);
    };
    Keycloak.prototype.logout = function (options) {
        return this.adapter.logout(options);
    };
    Keycloak.prototype.updateToken = function (minValidity) {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            minValidity = minValidity || 5;
            if (!_this.isTokenExpired(minValidity)) {
                // console.info('token still valid');
                observer.next(_this.accessToken);
            }
            else {
                if (_this.isRefreshTokenExpired(5)) {
                    _this.login(_this.config);
                }
                else {
                    // console.info('refreshing token');
                    var params = new http_1.URLSearchParams();
                    params.set('grant_type', 'refresh_token');
                    params.set('refresh_token', _this.refreshToken);
                    var url = _this.getRealmUrl() + '/protocol/openid-connect/token';
                    // console.info('getting url');
                    var headers = new http_1.Headers({
                        'Content-type': 'application/x-www-form-urlencoded'
                    });
                    if (_this.clientId && _this.clientSecret) {
                        headers.append('Authorization', 'Basic ' + btoa(_this.clientId + ': ' + _this.clientSecret));
                    }
                    else {
                        params.set('client_id', _this.clientId);
                    }
                    var timeLocal_1 = new Date().getTime();
                    var options = {
                        'headers': headers,
                        'withCredentials': true
                    };
                    // console.info('calling url ' + url);
                    _this.http.post(url, params, options).subscribe(function (token) {
                        timeLocal_1 = (timeLocal_1 + new Date().getTime()) / 2;
                        var tokenResponse = token.json();
                        // console.info('parsed access token ' + tokenResponse['access_token']);
                        _this.setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], true);
                        _this.timeSkew = Math.floor(timeLocal_1 / 1000) - _this.tokenParsed.iat;
                        observer.next(tokenResponse['access_token']);
                    });
                }
            }
        });
    };
    Keycloak.prototype.register = function (options) {
        return this.adapter.register(options);
    };
    Keycloak.prototype.accountManagement = function (options) {
        return this.adapter.accountManagement(options);
    };
    Keycloak.prototype.loadUserProfile = function () {
        var url = this.getRealmUrl() + '/account';
        var headers = new http_1.Headers({
            Accept: 'application/json',
            Authorization: 'bearer ' + this.accessToken
        });
        var options = { 'headers': headers };
        return this.http.get(url, options).map(function (profile) { return profile.json(); });
    };
    Keycloak.prototype.loadUserInfo = function () {
        var url = this.getRealmUrl() + '/protocol/openid-connect/userinfo';
        var headers = new http_1.Headers({
            'Accept': 'application/json',
            'Authorization': 'bearer ' + this.accessToken
        });
        var options = { 'headers': headers };
        return this.http.get(url, options).map(function (profile) { return profile.json(); });
    };
    Keycloak.prototype.hasRealmRole = function (role) {
        var access = this.realmAccess;
        return !!access && access.roles.indexOf(role) >= 0;
    };
    Keycloak.prototype.hasResourceRole = function (role, resource) {
        if (!this.resourceAccess) {
            return false;
        }
        var access = this.resourceAccess[resource || this.clientId];
        return !!access && access.roles.indexOf(role) >= 0;
    };
    Keycloak.prototype.isTokenExpired = function (minValidity) {
        if (!this.tokenParsed || (!this.refreshToken && this.flow !== 'implicit')) {
            throw new Error('Not authenticated');
        }
        var expiresIn = this.tokenParsed['exp'] - new Date().getTime() / 1000 + this.timeSkew;
        if (minValidity) {
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    };
    Keycloak.prototype.isRefreshTokenExpired = function (minValidity) {
        if (!this.tokenParsed || (!this.refreshToken && this.flow !== 'implicit')) {
            throw new Error('Not authenticated');
        }
        var expiresIn = this.refreshTokenParsed['exp'] -
            new Date().getTime() / 1000 +
            this.timeSkew;
        if (minValidity) {
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    };
    Keycloak.prototype.clearToken = function (initOptions) {
        if (this.accessToken) {
            this.setToken('', '', '', true);
            Keycloak_1.authenticatedBehaviourSubject.next(false);
            if (this.loginRequired) {
                this.login(initOptions);
            }
        }
    };
    // URLs methods
    Keycloak.prototype.createLoginUrl = function (options) {
        var state = angular2_uuid_1.UUID.UUID();
        var nonce = angular2_uuid_1.UUID.UUID();
        var redirectUri = this.adapter.redirectUri(options);
        if (options && options.prompt) {
            redirectUri +=
                (redirectUri.indexOf('?') === -1 ? '?' : '&') +
                    'prompt=' +
                    options.prompt;
        }
        this.callbackStorage.add({
            'state': state,
            'nonce': nonce,
            'redirectUri': redirectUri
        });
        var action = 'auth';
        if (options && options.action === 'register') {
            action = 'registrations';
        }
        var scope = options && options.scope ? 'openid ' + options.scope : 'openid';
        var url = this.getRealmUrl() +
            '/protocol/openid-connect/' +
            action +
            '?client_id=' +
            encodeURIComponent(this.clientId) +
            '&redirect_uri=' +
            encodeURIComponent(redirectUri) +
            '&state=' +
            encodeURIComponent(state) +
            '&nonce=' +
            encodeURIComponent(nonce) +
            '&response_mode=' +
            encodeURIComponent(this.responseMode) +
            '&response_type=' +
            encodeURIComponent(this.responseType) +
            '&scope=' +
            encodeURIComponent(scope);
        if (options && options.prompt) {
            url += '&prompt=' + encodeURIComponent(options.prompt);
        }
        if (options && options.maxAge) {
            url += '&max_age=' + encodeURIComponent(options.maxAge);
        }
        if (options && options.loginHint) {
            url += '&login_hint=' + encodeURIComponent(options.loginHint);
        }
        if (options && options.idpHint) {
            url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
        }
        if (options && options.locale) {
            url += '&ui_locales=' + encodeURIComponent(options.locale);
        }
        return url;
    };
    Keycloak.prototype.createLogoutUrl = function (options) {
        var url = this.getRealmUrl() +
            '/protocol/openid-connect/logout' +
            '?redirect_uri=' +
            encodeURIComponent(this.adapter.redirectUri(options, false));
        return url;
    };
    Keycloak.prototype.createRegisterUrl = function (options) {
        if (!options) {
            options = {};
        }
        options.action = 'register';
        return this.createLoginUrl(options);
    };
    Keycloak.prototype.createAccountUrl = function (options) {
        var url = this.getRealmUrl() +
            '/account' +
            '?referrer=' +
            encodeURIComponent(this.clientId) +
            '&referrer_uri=' +
            encodeURIComponent(this.adapter.redirectUri(options));
        return url;
    };
    Keycloak.prototype.getRealmUrl = function () {
        if (this.authServerUrl.charAt(this.authServerUrl.length - 1) === '/') {
            return this.authServerUrl + 'realms/' + encodeURIComponent(this.realm);
        }
        else {
            return this.authServerUrl + '/realms/' + encodeURIComponent(this.realm);
        }
    };
    Keycloak.prototype.checkLoginIframe = function () {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            if (_this.loginIframe.iframe && _this.loginIframe.iframeOrigin) {
                var msg = _this.clientId + ' ' + _this.sessionId;
                var origin = _this.loginIframe.iframeOrigin;
                // console.info("KC_CORE: sending message to iframe "+msg+" origin :"+origin);
                _this.loginIframe.iframe.contentWindow.postMessage(msg, origin);
                observer.next(true);
            }
            else {
                // promise.setSuccess();
                observer.next(true);
            }
        });
    };
    Keycloak.prototype.processCallback = function (oauth) {
        var _this = this;
        var code = oauth.code;
        var error = oauth.error;
        var prompt = oauth.prompt;
        var timeLocal = new Date().getTime();
        if (error) {
            if (prompt !== 'none') {
                var errorData = {
                    'error': error,
                    'error_description': oauth.error_description
                };
                Keycloak_1.authErrorBehaviourSubject.next(errorData);
            }
            return;
        }
        else if (this.flow !== 'standard' &&
            (oauth.access_token || oauth.id_token)) {
            authSuccess(oauth.access_token, '', oauth.id_token, true, this);
        }
        if (this.flow !== 'implicit' && code) {
            var url = this.getRealmUrl() + '/protocol/openid-connect/token';
            var params = new http_1.URLSearchParams();
            params.set('code', code);
            params.set('grant_type', 'authorization_code');
            var headers = new http_1.Headers({
                'Content-type': 'application/x-www-form-urlencoded'
            });
            if (this.clientId && this.clientSecret) {
                headers.append('Authorization', 'Basic ' + btoa(this.clientId + ':' + this.clientSecret));
            }
            else {
                params.set('client_id', this.clientId);
            }
            params.set('redirect_uri', oauth.redirectUri);
            var options = {
                'headers': headers,
                'withCredentials': false
            };
            this.http.post(url, params, options).subscribe(function (token) {
                var tokenResponse = token.json();
                authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], _this.flow === 'standard', _this);
            });
        }
        function authSuccess(accessToken, refreshToken, idToken, fulfillPromise, kc) {
            timeLocal = (timeLocal + new Date().getTime()) / 2;
            kc.setToken(accessToken, refreshToken, idToken, true);
            if ((kc.tokenParsed && kc.tokenParsed.nonce !== oauth.storedNonce) ||
                (kc.refreshTokenParsed &&
                    kc.refreshTokenParsed.nonce !== oauth.storedNonce) ||
                (kc.idTokenParsed && kc.idTokenParsed.nonce !== oauth.storedNonce)) {
                // console.log('invalid nonce!');
                kc.clearToken({});
            }
            else {
                kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
                if (fulfillPromise) {
                    Keycloak_1.authSuccessBehaviourSubject.next(true);
                }
            }
        }
    };
    Keycloak.prototype.setToken = function (accessToken, refreshToken, idToken, useTokenTime) {
        if (this.tokenTimeoutHandle) {
            clearTimeout(this.tokenTimeoutHandle);
            this.tokenTimeoutHandle = null;
        }
        if (this.refreshTokenTimeoutHandle) {
            clearTimeout(this.refreshTokenTimeoutHandle);
            this.refreshTokenTimeoutHandle = null;
        }
        if (accessToken) {
            this.accessToken = accessToken;
            this.tokenParsed = new keycloak_utils_token_1.Token().decodeToken(accessToken);
            this.sessionId = this.tokenParsed.session_state;
            Keycloak_1.authenticatedBehaviourSubject.next(true);
            this.subject = this.tokenParsed.sub;
            this.realmAccess = this.tokenParsed.realm_access;
            this.resourceAccess = this.tokenParsed.resource_access;
            var start = useTokenTime
                ? this.tokenParsed.iat
                : new Date().getTime() / 1000;
            var expiresIn = this.tokenParsed.exp - start;
            this.tokenTimeoutHandle = setTimeout(this.pushTokenExpired, expiresIn * 1000);
        }
        else {
            delete this.accessToken;
            delete this.tokenParsed;
            delete this.subject;
            delete this.realmAccess;
            delete this.resourceAccess;
        }
        if (refreshToken) {
            this.refreshToken = refreshToken;
            this.refreshTokenParsed = new keycloak_utils_token_1.Token().decodeToken(refreshToken);
            var start = useTokenTime
                ? this.refreshTokenParsed.iat
                : new Date().getTime() / 1000;
            var expiresIn = this.refreshTokenParsed.exp - start;
            this.refreshTokenTimeoutHandle = setTimeout(this.pushRefreshTokenExpired, expiresIn * 1000);
        }
        else {
            delete this.refreshToken;
            delete this.refreshTokenParsed;
        }
        if (idToken) {
            this.idToken = idToken;
            this.idTokenParsed = new keycloak_utils_token_1.Token().decodeToken(idToken);
        }
        else {
            delete this.idToken;
            delete this.idTokenParsed;
        }
    };
    Keycloak.prototype.pushTokenExpired = function () {
        Keycloak_1.tokenExpiredBehaviourSubject.next(true);
    };
    Keycloak.prototype.pushRefreshTokenExpired = function () {
        Keycloak_1.refreshTokenExpiredBehaviourSubject.next(true);
    };
    Keycloak.prototype.createCallbackId = function () {
        var id = '<id: ' + this.callback_id++ + Math.random() + '>';
        return id;
    };
    Keycloak.prototype.parseCallback = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var oauth, state, oauthState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oauth = keycloak_utils_URIParser_1.URIParser.parseUri(url, this.responseMode);
                        state = oauth.state;
                        return [4 /*yield*/, this.callbackStorage.get(state)];
                    case 1:
                        oauthState = _a.sent();
                        if (oauthState &&
                            (oauth.code || oauth.error || oauth.access_token || oauth.id_token)) {
                            oauth.redirectUri = oauthState.redirectUri;
                            oauth.storedNonce = oauthState.nonce;
                            if (oauth.fragment) {
                                oauth.newUrl += '#' + oauth.fragment;
                            }
                            return [2 /*return*/, oauth];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Keycloak.prototype.init = function (initOptions) {
        var _this = this;
        // console.info('KC_CORE: init called...');
        if (common_1.isPlatformBrowser(this.platformId) &&
            !Keycloak_1.initializedBehaviourSubject.getValue() &&
            !this.lock.isAquired()) {
            this.lock.acquire();
            // console.info('KC_CORE: initializing...');
            if (initOptions && initOptions.adapter === 'ionic') {
                this.callbackStorage = this.ionicStorageService;
            }
            else {
                try {
                    this.callbackStorage = new keycloak_storage_local_1.LocalStorage();
                }
                catch (err) {
                    this.callbackStorage = new keycloak_storage_cookie_1.CookieStorage();
                }
            }
            if (initOptions && initOptions.adapter === 'cordova') {
                this.adapter = this.loadAdapter('cordova');
            }
            else if (initOptions && initOptions.adapter === 'default') {
                this.adapter = this.loadAdapter('default');
            }
            else {
                if (window && window['cordova']) {
                    this.adapter = this.loadAdapter('cordova');
                }
                else {
                    this.adapter = this.loadAdapter('default');
                }
            }
            // options processing
            if (initOptions) {
                if (typeof initOptions.checkLoginIframe !== 'undefined') {
                    this.loginIframe.enable = initOptions.checkLoginIframe;
                }
                if (initOptions.checkLoginIframeInterval) {
                    this.loginIframe.interval = initOptions.checkLoginIframeInterval;
                }
                if (initOptions.onLoad === 'login-required') {
                    this.loginRequired = true;
                }
                if (initOptions.responseMode) {
                    if (initOptions.responseMode === 'query' ||
                        initOptions.responseMode === 'fragment') {
                        this.responseMode = initOptions.responseMode;
                    }
                    else {
                        throw new Error('Invalid value for responseMode');
                    }
                }
                if (initOptions.flow) {
                    switch (initOptions.flow) {
                        case 'standard':
                            this.responseType = 'code';
                            break;
                        case 'implicit':
                            this.responseType = 'id_token token';
                            break;
                        case 'hybrid':
                            this.responseType = 'code id_token token';
                            break;
                        default:
                            throw new Error('Invalid value for flow');
                    }
                    this.flow = initOptions.flow;
                }
            }
            if (!this.responseMode) {
                this.responseMode = 'fragment';
            }
            if (!this.responseType) {
                this.responseType = 'code';
                this.flow = 'standard';
            }
            // loading this conf
            this.loadConfig(this.config).subscribe(function (loaded) {
                if (loaded) {
                    Keycloak_1.initializedBehaviourSubject.next(true);
                    _this.processInit(initOptions, _this).subscribe(function (initialized) {
                        // console.info("KC_CORE : notifying initialized");
                        // this.initializingBehaviourSubject.next(false);
                    });
                }
            });
        }
    };
    Keycloak.prototype.loadConfig = function (configuration) {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            var configUrl = '';
            if (!configuration) {
                configUrl = 'keycloak.json';
            }
            else if (typeof configuration === 'string') {
                configUrl = configuration;
            }
            if (configUrl !== '') {
                _this.http
                    .get(configUrl)
                    .map(function (res) { return res.json(); })
                    .subscribe(function (config) {
                    _this.authServerUrl = config['auth-server-url'];
                    _this.realm = config['realm'];
                    _this.clientId = config['resource'];
                    _this.clientSecret = (config['credentials'] || {})['secret'];
                    observer.next(true);
                    // console.info("Keycloak initialized !");
                });
            }
            else {
                if (!configuration['realm']) {
                    throw new Error('realm missing');
                }
                if (!configuration['resource']) {
                    throw new Error('clientId missing');
                }
                if (!configuration['auth-server-url']) {
                    throw new Error('auth server url missing');
                }
                _this.authServerUrl = configuration['auth-server-url'];
                _this.realm = configuration['realm'];
                _this.clientId = configuration['resource'];
                _this.clientSecret = (configuration.credentials || {}).secret;
                observer.next(true);
            }
        });
    };
    Keycloak.prototype.processInit = function (initOptions, kc) {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            if (window) {
                return Rx_1.Observable.fromPromise(_this.parseCallback(window.location.href)).subscribe(function (callback) {
                    if (callback) {
                        _this.setupCheckLoginIframe(kc).subscribe(function (setup) {
                            // console.info("KC_CORE: replacing window url");
                            window.history.replaceState({}, null, callback.newUrl);
                            _this.processCallback(callback);
                        });
                    }
                    else if (initOptions) {
                        if (initOptions.token || initOptions.refreshToken) {
                            _this.setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken, false);
                            _this.timeSkew = initOptions.timeSkew || 0;
                            if (_this.loginIframe.enable) {
                                _this.setupCheckLoginIframe(kc).subscribe(function (setup) {
                                    _this.checkLoginIframe().subscribe(function (checked) {
                                        observer.next(true);
                                    });
                                });
                            }
                            else {
                                observer.next(true);
                            }
                        }
                        else if (initOptions.onLoad) {
                            var options_1 = {};
                            var doLogin_1 = function doLoginCall(prompt) {
                                if (!prompt) {
                                    options_1.prompt = 'none';
                                }
                                kc.login(options_1);
                            };
                            switch (initOptions.onLoad) {
                                case 'check-sso':
                                    // console.info('login iframe ? '+Keycloak.loginIframe.enable);
                                    if (_this.loginIframe.enable) {
                                        _this.setupCheckLoginIframe(kc).subscribe(function (setup) {
                                            _this.checkLoginIframe().subscribe(function (checked) {
                                                doLogin_1(false);
                                            });
                                        });
                                    }
                                    else {
                                        doLogin_1(false);
                                    }
                                    break;
                                case 'login-required':
                                    doLogin_1(true);
                                    break;
                                default:
                                    throw new Error('Invalid value for onLoad');
                            }
                        }
                        else {
                            observer.next(true);
                        }
                    }
                    else {
                        observer.next(true);
                    }
                });
                // let initPromise:any = Keycloak.createPromise;
            }
        });
    };
    Keycloak.prototype.setupCheckLoginIframe = function (kc) {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            // console.info('Configuring login iframe...');
            if (!_this.loginIframe.enable) {
                // console.info('login iframe IS NOT enabled');
                observer.next(true);
                return;
            }
            if (_this.loginIframe.iframe) {
                // console.info('login iframe enabled and already created');
                observer.next(true);
                return;
            }
            var iframe = document.createElement('iframe');
            _this.loginIframe.iframe = iframe;
            var check = function execCheck() {
                // Keycloak.checkLoginIframe().subscribe(check => {
                // console.info('iframe checked');
                // });
                if (kc.accessToken) {
                    setTimeout(check, kc.loginIframe.interval * 1000);
                }
            };
            iframe.keycloak = kc;
            iframe.onload = function iframeOnLoad() {
                var realmUrl = this.keycloak.getRealmUrl();
                if (realmUrl.charAt(0) === '/') {
                    // const origin: any;
                    if (window && !window.location.origin) {
                        this.keycloak.loginIframe.iframeOrigin =
                            window.location.protocol +
                                '//' +
                                window.location.hostname +
                                (window.location.port ? ': ' + window.location.port : '');
                    }
                    else {
                        this.keycloak.loginIframe.iframeOrigin = window.location.origin;
                    }
                }
                else {
                    this.keycloak.loginIframe.iframeOrigin = realmUrl.substring(0, realmUrl.indexOf('/', 8));
                }
                // console.info('login iframe LOADED');
                observer.next(true);
                setTimeout(check, this.keycloak.loginIframe.interval * 1000);
            };
            var src = _this.getRealmUrl() +
                '/protocol/openid-connect/login-status-iframe.html';
            // console.info('configuring iframe url to ' + src);
            iframe.setAttribute('src', src);
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            var messageCallback = function getMessageCallback(event) {
                // console.info('checking iframe message callback..'+event.data+' '+event.origin);
                if (event.origin !== kc.loginIframe.iframeOrigin ||
                    kc.loginIframe.iframe.contentWindow !== event.source) {
                    // console.info('event is not coming from the iframe, ignoring it');
                    return;
                }
                if (!(event.data === 'unchanged' ||
                    event.data === 'changed' ||
                    event.data === 'error')) {
                    // console.info('unknown event data, ignoring it');
                    return;
                }
                if (event.data !== 'unchanged') {
                    // console.info('event from the iframe, and data changed, clearing tokens');
                    kc.clearToken({});
                }
            };
            window.addEventListener('message', messageCallback, false);
        });
    };
    Keycloak.prototype.loadAdapter = function (type) {
        if (!type || type === 'default') {
            return new keycloak_adapter_default_1.DefaultAdapter(this);
        }
        if (type === 'cordova') {
            return new keycloak_adapter_cordova_1.CordovaAdapter(this);
        }
        throw new Error('invalid adapter type: ' + type);
    };
    // Keycloak state subjects
    Keycloak.initializedBehaviourSubject = new Rx_1.BehaviorSubject(false);
    Keycloak.initializingBehaviourSubject = new Rx_1.BehaviorSubject(false);
    Keycloak.authenticatedBehaviourSubject = new Rx_1.BehaviorSubject(false);
    Keycloak.authSuccessBehaviourSubject = new Rx_1.BehaviorSubject(false);
    Keycloak.authErrorBehaviourSubject = new Rx_1.BehaviorSubject({});
    Keycloak.tokenExpiredBehaviourSubject = new Rx_1.BehaviorSubject(false);
    Keycloak.refreshTokenExpiredBehaviourSubject = new Rx_1.BehaviorSubject(false);
    // Keycloak state observables
    Keycloak.initializedObs = Keycloak_1.initializedBehaviourSubject.asObservable();
    Keycloak.initializingObs = Keycloak_1.initializingBehaviourSubject.asObservable();
    Keycloak.authenticatedObs = Keycloak_1.authenticatedBehaviourSubject.asObservable();
    Keycloak.authSuccessObs = Keycloak_1.authSuccessBehaviourSubject.asObservable();
    Keycloak.authErrorObs = Keycloak_1.authErrorBehaviourSubject.asObservable();
    Keycloak.tokenExpiredObs = Keycloak_1.tokenExpiredBehaviourSubject.asObservable();
    Keycloak.refreshTokenExpiredObs = Keycloak_1.refreshTokenExpiredBehaviourSubject.asObservable();
    Keycloak = Keycloak_1 = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject(core_1.PLATFORM_ID)),
        __metadata("design:paramtypes", [keycloak_storage_ionic_1.IonicStorage, Object])
    ], Keycloak);
    return Keycloak;
    var Keycloak_1;
}());
exports.Keycloak = Keycloak;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(2);
var Rx_1 = __webpack_require__(3);
var keycloak_core_service_1 = __webpack_require__(1);
__webpack_require__(4);
/**
 * Keycloak Authorization manager.
 *
 * Manager authorization headers and tokens to access to protected resources.
 */
var KeycloakAuthorization = (function () {
    // constructor
    function KeycloakAuthorization(keycloak) {
        this.keycloak = keycloak;
    }
    KeycloakAuthorization_1 = KeycloakAuthorization;
    /**
     * This method enables client applications to better integrate with resource servers protected by a Keycloak
     * policy enforcer.
     *
     * In this case, the resource server will respond with a 401 status code and a WWW-Authenticate header holding the
     * necessary information to ask a Keycloak server for authorization data using both UMA and Entitlement protocol,
     * depending on how the policy enforcer at the resource server was configured.
     */
    KeycloakAuthorization.prototype.authorize = function (wwwAuthenticateHeader) {
        var _this = this;
        if (wwwAuthenticateHeader.indexOf('UMA') !== -1) {
            var params = wwwAuthenticateHeader.split(',');
            var headers = void 0;
            var body = void 0;
            for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
                var param = params_1[_i];
                var paramValue = param.split('=');
                if (paramValue[0] === 'ticket') {
                    var ticket = paramValue[1]
                        .substring(1, paramValue[1].length - 1)
                        .trim();
                    headers = new http_1.Headers({ 'Content-type': 'application/json' });
                    headers.append('Authorization', 'Bearer ' + this.keycloak.accessToken);
                    body = JSON.stringify({
                        'ticket': ticket,
                        'rpt': this.rpt
                    });
                }
            }
            var options = { 'headers': headers };
            return this.keycloak.http
                .post(this.config.rpt_endpoint, body, options)
                .map(function (token) {
                var status = token.status;
                if (status >= 200 && status < 300) {
                    // Token retrieved
                    var rpt = JSON.parse(token.text()).rpt;
                    _this.rpt = rpt;
                    return rpt;
                }
                else if (status === 403) {
                    // console.error('Authorization request was denied by the server.');
                    Rx_1.Observable.throw('Authorization request was denied by the server.');
                }
                else {
                    // console.error('Could not obtain authorization data from server.');
                    Rx_1.Observable.throw('Could not obtain authorization data from server.');
                }
            });
        }
        else if (wwwAuthenticateHeader.indexOf('KC_ETT') !== -1) {
            var params = wwwAuthenticateHeader
                .substring('KC_ETT'.length)
                .trim()
                .split(',');
            var clientId = '';
            for (var _a = 0, params_2 = params; _a < params_2.length; _a++) {
                var param = params_2[_a];
                var paramValue = param.split('=');
                if (paramValue[0] === 'realm') {
                    clientId = paramValue[1]
                        .substring(1, paramValue[1].length - 1)
                        .trim();
                }
            }
            return this.entitlement(clientId);
        }
        return Rx_1.Observable.throw('Unable to authorize');
    };
    /**
     * Obtains all entitlements from a this Server based on a give resourceServerId.
     */
    KeycloakAuthorization.prototype.entitlement = function (resourceSeververId) {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            var url = _this.keycloak.authServerUrl +
                '/realms/' +
                _this.keycloak.realm +
                '/authz/entitlement/' +
                resourceSeververId;
            var headers = new http_1.Headers({
                Authorization: 'Bearer ' + _this.keycloak.accessToken
            });
            var options = { 'headers': headers };
            _this.keycloak.http.get(url, options).map(function (token) {
                var status = token.status;
                if (status >= 200 && status < 300) {
                    var rpt = JSON.parse(token.text()).rpt;
                    _this.rpt = rpt;
                    observer.next(rpt);
                }
                else if (status === 403) {
                    // console.error('Authorization request was denied by the server.');
                    Rx_1.Observable.throw('Authorization request was denied by the server.');
                }
                else {
                    // console.error('Could not obtain authorization data from server.');
                    Rx_1.Observable.throw('Authorization request was denied by the server.');
                }
            });
        });
    };
    KeycloakAuthorization.prototype.init = function () {
        var _this = this;
        // console.debug('KC_AUTHZ: this init authz...');
        if (!KeycloakAuthorization_1.initializedBehaviourSubject.getValue()) {
            keycloak_core_service_1.Keycloak.initializedObs
                .filter(function (status) { return status === true; })
                .subscribe(function (status) {
                // console.debug('KC_AUTHZ: this initialized, loading authz...');
                // using hostname in url is a hack to bypass CORS errors due to KC cache-control
                var url = _this.keycloak.authServerUrl +
                    '/realms/' +
                    _this.keycloak.realm +
                    '/.well-known/uma-configuration' + '?origin=' + window.location.hostname;
                var headers = new http_1.Headers({ 'Accept': 'application/json' });
                var options = { 'headers': headers };
                _this.keycloak.http.get(url, options).subscribe(function (authz) {
                    _this.config = authz.json();
                    // notifying initialization
                    KeycloakAuthorization_1.initializedBehaviourSubject.next(true);
                });
            });
        }
        // this.this.init({});
    };
    KeycloakAuthorization.initializedBehaviourSubject = new Rx_1.BehaviorSubject(false);
    KeycloakAuthorization.initializedObs = KeycloakAuthorization_1.initializedBehaviourSubject.asObservable();
    KeycloakAuthorization = KeycloakAuthorization_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [keycloak_core_service_1.Keycloak])
    ], KeycloakAuthorization);
    return KeycloakAuthorization;
    var KeycloakAuthorization_1;
}());
exports.KeycloakAuthorization = KeycloakAuthorization;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var keycloak_core_service_1 = __webpack_require__(1);
var core_1 = __webpack_require__(0);
/**
 * Default adapter for web browsers
 */
var DefaultAdapter = (function () {
    function DefaultAdapter(keycloak) {
        this.keycloak = keycloak;
    }
    DefaultAdapter.prototype.login = function (options) {
        if (window) {
            window.location.href = this.keycloak.createLoginUrl(options);
        }
    };
    DefaultAdapter.prototype.logout = function (options) {
        if (window) {
            window.location.href = this.keycloak.createLogoutUrl(options);
        }
    };
    DefaultAdapter.prototype.register = function (options) {
        if (window) {
            window.location.href = this.keycloak.createRegisterUrl(options);
        }
    };
    DefaultAdapter.prototype.accountManagement = function () {
        if (window) {
            window.location.href = this.keycloak.createAccountUrl({});
        }
    };
    DefaultAdapter.prototype.redirectUri = function (options, encodeHash) {
        if (arguments.length === 1) {
            encodeHash = true;
        }
        if (options && options.redirectUri) {
            return options.redirectUri;
        }
        else {
            var redirectUri = location.href;
            if (location.hash && encodeHash) {
                redirectUri = redirectUri.substring(0, location.href.indexOf('#'));
                redirectUri +=
                    (redirectUri.indexOf('?') === -1 ? '?' : '&') +
                        'redirect_fragment=' +
                        encodeURIComponent(location.hash.substring(1));
            }
            return redirectUri;
        }
    };
    DefaultAdapter = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [keycloak_core_service_1.Keycloak])
    ], DefaultAdapter);
    return DefaultAdapter;
}());
exports.DefaultAdapter = DefaultAdapter;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var keycloak_core_service_1 = __webpack_require__(1);
var core_1 = __webpack_require__(0);
/**
 * Cordova adapter for hybrid apps.
 */
var CordovaAdapter = (function () {
    function CordovaAdapter(keycloak) {
        this.keycloak = keycloak;
    }
    CordovaAdapter.prototype.openBrowserTab = function (url, target, options) {
        if (window.cordova && window.cordova.InAppBrowser) {
            // Use inappbrowser for IOS and Android if available
            return window.cordova.InAppBrowser.open(url, target, options);
        }
        else {
            return window.open(url, target, options);
        }
    };
    CordovaAdapter.prototype.login = function (options) {
        var _this = this;
        var o = 'location=no';
        if (options && options.prompt === 'none') {
            o += ',hidden=yes';
        }
        var loginUrl = this.keycloak.createLoginUrl(options);
        var ref = this.openBrowserTab(loginUrl, '_blank', o);
        var completed = false;
        ref.addEventListener('loadstart', function (event) {
            if (event.url.indexOf('http://localhost') === 0) {
                var callback = _this.keycloak.parseCallback(event.url);
                _this.keycloak.processCallback(callback);
                ref.close();
                completed = true;
            }
        });
        ref.addEventListener('loaderror', function (event) {
            if (!completed) {
                if (event.url.indexOf('http://localhost') === 0) {
                    var callback = _this.keycloak.parseCallback(event.url);
                    _this.keycloak.processCallback(callback);
                    ref.close();
                    completed = true;
                }
                else {
                    ref.close();
                }
            }
        });
    };
    CordovaAdapter.prototype.closeBrowserTab = function () {
        var cordova = window.cordova;
        cordova.plugins.browsertab.themeable.close();
        // completed = true;
    };
    CordovaAdapter.prototype.logout = function (options) {
        var cordova = window.cordova;
        var logoutUrl = this.keycloak.createLogoutUrl(options);
        var ref;
        var error;
        cordova.plugins.browsertab.themeable.isAvailable(function logoutInTab(result, kc) {
            if (!result) {
                ref = cordova.InAppBrowser.open(logoutUrl, '_system');
                ref.addEventListener('loadstart', function processLogoutLoadStartEvent(event) {
                    if (event.url.indexOf('http://localhost') === 0) {
                        ref.close();
                    }
                });
                ref.addEventListener('loaderror', function processLogoutLoadErrorEvent(event) {
                    if (event.url.indexOf('http://localhost') === 0) {
                        ref.close();
                    }
                    else {
                        error = true;
                        ref.close();
                    }
                });
                ref.addEventListener('exit', function processLogoutExitEvent(event) {
                    if (error) {
                        // promise.setError();
                    }
                    else {
                        kc.keycloak.clearToken({});
                        // promise.setSuccess();
                    }
                });
            }
            else {
                kc.openBrowserTab(logoutUrl, options);
            }
        }, function logoutNotAvailable(isAvailableError) {
            // console.info('failed to query availability of in-app browser tab');
        });
    };
    CordovaAdapter.prototype.register = function (options) {
        var registerUrl = this.keycloak.createRegisterUrl({});
        window.cordova.plugins.browsertab.themeable.isAvailable(function registerInTab(result, kc) {
            if (!result) {
                window.cordova.InAppBrowser.open(registerUrl, '_system');
            }
            else {
                kc.openBrowserTab(registerUrl, options);
            }
        }, function registerTabNotAvailable(isAvailableError) {
            // console.info('failed to query availability of in-app browser tab');
        });
    };
    CordovaAdapter.prototype.accountManagement = function (options) {
        var accountUrl = this.keycloak.createAccountUrl({});
        window.cordova.plugins.browsertab.themeable.isAvailable(function accountInTab(result, kc) {
            if (!result) {
                window.cordova.InAppBrowser.open(accountUrl, '_system');
            }
            else {
                kc.openBrowserTab(accountUrl, options);
            }
        }, function accountInTabNotAvailable(isAvailableError) {
            // console.info('failed to query availability of in-app browser tab');
        });
    };
    CordovaAdapter.prototype.redirectUri = function (options) {
        if (options.redirectUri) {
            return options.redirectUri;
        }
        else {
            // should use deep link
            return 'http://localhost';
        }
    };
    CordovaAdapter = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [keycloak_core_service_1.Keycloak])
    ], CordovaAdapter);
    return CordovaAdapter;
}());
exports.CordovaAdapter = CordovaAdapter;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * To store Keycloak objects like tokens using a localStorage.
 */
var LocalStorage = (function () {
    function LocalStorage() {
    }
    LocalStorage.prototype.clearExpired = function () {
        var time = new Date().getTime();
        for (var i = 1; i <= localStorage.length; i++) {
            var key = localStorage.key(i);
            if (key && key.indexOf('kc-callback-') === 0) {
                var value = localStorage.getItem(key);
                if (value) {
                    try {
                        var expires = JSON.parse(value).expires;
                        if (!expires || expires < time) {
                            localStorage.removeItem(key);
                        }
                    }
                    catch (err) {
                        localStorage.removeItem(key);
                    }
                }
            }
        }
    };
    LocalStorage.prototype.get = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            var key, value;
            return __generator(this, function (_a) {
                if (!state) {
                    return [2 /*return*/];
                }
                key = 'kc-callback-' + state;
                value = localStorage.getItem(key);
                if (value) {
                    localStorage.removeItem(key);
                    value = JSON.parse(value);
                }
                this.clearExpired();
                return [2 /*return*/, value];
            });
        });
    };
    LocalStorage.prototype.add = function (state) {
        this.clearExpired();
        var key = 'kc-callback-' + state.state;
        state.expires = new Date().getTime() + 60 * 60 * 1000;
        localStorage.setItem(key, JSON.stringify(state));
    };
    return LocalStorage;
}());
exports.LocalStorage = LocalStorage;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * To store Keycloak objects like tokens using a cookie.
 */
var CookieStorage = (function () {
    function CookieStorage() {
        this.getCookie = function getCookieFromKey(key) {
            var name = key + '=';
            var ca = document.cookie.split(';');
            for (var _i = 0, ca_1 = ca; _i < ca_1.length; _i++) {
                var c = ca_1[_i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        };
    }
    CookieStorage.prototype.get = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                if (!state) {
                    return [2 /*return*/];
                }
                value = this.getCookie('kc-callback-' + state);
                this.setCookie('kc-callback-' + state, '', this.cookieExpiration(-100));
                if (value) {
                    return [2 /*return*/, JSON.parse(value)];
                }
                return [2 /*return*/];
            });
        });
    };
    CookieStorage.prototype.add = function (state) {
        this.setCookie('kc-callback-' + state.state, JSON.stringify(state), this.cookieExpiration(60));
    };
    CookieStorage.prototype.removeItem = function (key) {
        this.setCookie(key, '', this.cookieExpiration(-100));
    };
    CookieStorage.prototype.cookieExpiration = function (minutes) {
        var exp = new Date();
        exp.setTime(exp.getTime() + minutes * 60 * 1000);
        return exp;
    };
    CookieStorage.prototype.setCookie = function (key, value, expirationDate) {
        var cookie = key +
            '=' +
            value +
            '; ' +
            'expires=' +
            expirationDate.toUTCString() +
            '; ';
        document.cookie = cookie;
    };
    return CookieStorage;
}());
exports.CookieStorage = CookieStorage;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * URI parser.
 */
var URIParser = (function () {
    function URIParser() {
    }
    URIParser.initialParse = function (uriToParse, responseMode) {
        var baseUri = '';
        var queryString = '';
        var fragmentString = '';
        var questionMarkIndex = uriToParse.indexOf('?');
        var fragmentIndex = uriToParse.indexOf('#', questionMarkIndex + 1);
        if (questionMarkIndex === -1 && fragmentIndex === -1) {
            baseUri = uriToParse;
        }
        else if (questionMarkIndex !== -1) {
            baseUri = uriToParse.substring(0, questionMarkIndex);
            queryString = uriToParse.substring(questionMarkIndex + 1);
            if (fragmentIndex !== -1) {
                fragmentIndex = queryString.indexOf('#');
                fragmentString = queryString.substring(fragmentIndex + 1);
                queryString = queryString.substring(0, fragmentIndex);
            }
        }
        else {
            baseUri = uriToParse.substring(0, fragmentIndex);
            fragmentString = uriToParse.substring(fragmentIndex + 1);
        }
        return {
            'baseUri': baseUri,
            'queryString': queryString,
            'fragmentString': fragmentString
        };
    };
    URIParser.parseParams = function (paramString) {
        var result = {};
        var params = paramString.split('&');
        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
            var pIt = params_1[_i];
            var p = pIt.split('=');
            var paramName = decodeURIComponent(p[0]);
            var paramValue = decodeURIComponent(p[1]);
            result[paramName] = paramValue;
        }
        return result;
    };
    URIParser.handleQueryParam = function (paramName, paramValue, oauth) {
        var supportedOAuthParams = [
            'code',
            'state',
            'error',
            'error_description'
        ];
        for (var _i = 0, supportedOAuthParams_1 = supportedOAuthParams; _i < supportedOAuthParams_1.length; _i++) {
            var paramNameIt = supportedOAuthParams_1[_i];
            if (paramName === paramNameIt) {
                oauth[paramName] = paramValue;
                return true;
            }
        }
        return false;
    };
    URIParser.parseUri = function (uriToParse, responseMode) {
        var parsedUri = this.initialParse(decodeURIComponent(uriToParse), responseMode);
        var queryParams = {};
        if (parsedUri.queryString) {
            queryParams = this.parseParams(parsedUri.queryString);
        }
        var oauth = { newUrl: parsedUri.baseUri };
        for (var param in queryParams) {
            if (param) {
                switch (param) {
                    case 'redirect_fragment':
                        oauth.fragment = queryParams[param];
                        break;
                    case 'prompt':
                        oauth.prompt = queryParams[param];
                        break;
                    default:
                        if (responseMode !== 'query' ||
                            !this.handleQueryParam(param, queryParams[param], oauth)) {
                            oauth.newUrl +=
                                (oauth.newUrl.indexOf('?') === -1 ? '?' : '&') +
                                    param +
                                    '=' +
                                    queryParams[param];
                        }
                        break;
                }
            }
        }
        if (responseMode === 'fragment') {
            var fragmentParams = {};
            if (parsedUri.fragmentString) {
                fragmentParams = this.parseParams(parsedUri.fragmentString);
            }
            for (var param in fragmentParams) {
                if (param) {
                    oauth[param] = fragmentParams[param];
                }
            }
        }
        return oauth;
    };
    return URIParser;
}());
exports.URIParser = URIParser;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A login iframe.
 */
var LoginIframe = (function () {
    function LoginIframe(enable, callbackMap, interval) {
        this.enable = enable;
        this.callbackMap = callbackMap;
        this.interval = interval;
    }
    return LoginIframe;
}());
exports.LoginIframe = LoginIframe;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Token utility
 */
var Token = (function () {
    function Token() {
    }
    Token.prototype.decodeToken = function (str) {
        str = str.split('.')[1];
        str = str.replace('/-/g', '+');
        str = str.replace('/_/g', '/');
        switch (str.length % 4) {
            case 0:
                break;
            case 2:
                str += '==';
                break;
            case 3:
                str += '=';
                break;
            default:
                throw new Error('Invalid token');
        }
        str = (str + '===').slice(0, str.length + str.length % 4);
        str = str.replace(/-/g, '+').replace(/_/g, '/');
        str = decodeURIComponent(atob(str));
        str = JSON.parse(str);
        return str;
    };
    return Token;
}());
exports.Token = Token;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by emilienbondu on 04/07/2017.
 */
var Lock = (function () {
    function Lock() {
        this._aquired = false;
    }
    Lock.getInstance = function () {
        return Lock._instance || (Lock._instance = new Lock());
    };
    Lock.prototype.acquire = function () {
        this._aquired = true;
    };
    Lock.prototype.release = function () {
        this._aquired = false;
    };
    Lock.prototype.isAquired = function () {
        return this._aquired;
    };
    Lock._instance = new Lock();
    return Lock;
}());
exports.Lock = Lock;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var storage_1 = __webpack_require__(20);
/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * To store Keycloak objects like tokens using a localStorage.
 */
var IonicStorage = (function () {
    function IonicStorage(storage) {
        this.storage = storage;
    }
    IonicStorage.prototype.clearExpired = function () {
        var _this = this;
        var time = new Date().getTime();
        this.storage.forEach(function (value, key) {
            if (key && key.indexOf('kc-callback-') === 0) {
                if (value) {
                    try {
                        var expires = JSON.parse(value).expires;
                        if (!expires || expires < time) {
                            _this.storage.remove(key);
                        }
                    }
                    catch (err) {
                        _this.storage.remove(key);
                    }
                }
            }
        });
    };
    IonicStorage.prototype.get = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            var key, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!state) {
                            return [2 /*return*/];
                        }
                        key = 'kc-callback-' + state;
                        return [4 /*yield*/, this.storage.get(key)];
                    case 1:
                        value = _a.sent();
                        if (value) {
                            this.storage.remove(key);
                            value = JSON.parse(value);
                        }
                        this.clearExpired();
                        return [2 /*return*/, value];
                }
            });
        });
    };
    IonicStorage.prototype.add = function (state) {
        this.clearExpired();
        var key = 'kc-callback-' + state.state;
        state.expires = new Date().getTime() + 60 * 60 * 1000;
        this.storage.set(key, JSON.stringify(state));
    };
    IonicStorage = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [storage_1.Storage])
    ], IonicStorage);
    return IonicStorage;
}());
exports.IonicStorage = IonicStorage;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(2);
var Rx_1 = __webpack_require__(3);
__webpack_require__(4);
__webpack_require__(24);
__webpack_require__(25);
var keycloak_auth_service_1 = __webpack_require__(5);
var keycloak_core_service_1 = __webpack_require__(1);
/**
 * An Angular http proxy supporting Keycloak auth & authz.
 * Authenticate user, manage tokens and add authorization header to access to remote Keycloak protected resources.
 */
var KeycloakHttp = (function (_super) {
    __extends(KeycloakHttp, _super);
    function KeycloakHttp(backend, defaultOptions, keycloakAuth, keycloak) {
        var _this = _super.call(this, backend, defaultOptions) || this;
        _this.keycloakAuth = keycloakAuth;
        _this.keycloak = keycloak;
        _this.MAX_UNAUTHORIZED_ATTEMPTS = 2;
        _this.keycloak.http = new http_1.Http(backend, defaultOptions);
        return _this;
        // this.this.init({});
        // this.thisAuth.init();
    }
    KeycloakHttp_1 = KeycloakHttp;
    KeycloakHttp.prototype.get = function (url, options) {
        // console.info("GET");
        options = options || { withCredentials: false };
        options.method = http_1.RequestMethod.Get;
        return this.configureRequest(url, 1, options);
    };
    KeycloakHttp.prototype.post = function (url, body, options) {
        options = options || { withCredentials: false };
        options.method = http_1.RequestMethod.Post;
        options.body = body;
        return this.configureRequest(url, 1, options);
    };
    KeycloakHttp.prototype.put = function (url, body, options) {
        options = options || { withCredentials: false };
        options.method = http_1.RequestMethod.Put;
        options.body = body;
        return this.configureRequest(url, 1, options);
    };
    KeycloakHttp.prototype.delete = function (url, options) {
        options = options || { withCredentials: false };
        options.method = http_1.RequestMethod.Delete;
        return this.configureRequest(url, 1, options);
    };
    KeycloakHttp.prototype.patch = function (url, body, options) {
        options = options || { withCredentials: false };
        options.method = http_1.RequestMethod.Patch;
        options.body = body;
        return this.configureRequest(url, 1, options);
    };
    KeycloakHttp.prototype.head = function (url, options) {
        options = options || { withCredentials: false };
        options.method = http_1.RequestMethod.Head;
        return this.configureRequest(url, 1, options);
    };
    KeycloakHttp.prototype.configureRequest = function (url, count, options) {
        var _this = this;
        if (options &&
            options.withCredentials &&
            !KeycloakHttp_1.readyBehaviourSubject.getValue()) {
            keycloak_auth_service_1.KeycloakAuthorization.initializedObs
                .take(1)
                .filter(function (init) { return init === true; })
                .subscribe(function () {
                // console.info('KC_HTTP: this authz initialized...');
            });
            keycloak_core_service_1.Keycloak.initializedObs
                .take(1)
                .filter(function (init) { return init === true; })
                .subscribe(function () {
                if (!keycloak_core_service_1.Keycloak.authenticatedBehaviourSubject.getValue()) {
                    // console.info('KC_HTTP: this initialized, go login...');
                    _this.keycloak.login(true);
                }
            });
            keycloak_core_service_1.Keycloak.authenticatedObs
                .take(2)
                .filter(function (auth) { return auth === true; })
                .subscribe(function () {
                // console.info('KC_HTTP: authentication done...');
                KeycloakHttp_1.readyBehaviourSubject.next(true);
            });
            return KeycloakHttp_1.readyObs
                .take(2)
                .filter(function (ready) { return ready === true; })
                .flatMap(function (ready) {
                // console.info('KC_HTTP: this is now http ready, re-attempting request...');
                return _this.configureRequest(url, count, options);
            });
        }
        else {
            // KC is ready, getting authorization header
            return this.setHeaders(options)
                .flatMap(function (opt) {
                // console.info('KC_HTTP: using headers ' + options);
                // calling http with headers
                return _super.prototype.request.call(_this, url, opt).catch(function (error) {
                    // error handling
                    var status = error.status;
                    if ((status === 403 || status === 401) &&
                        count < _this.MAX_UNAUTHORIZED_ATTEMPTS) {
                        // console.info('KC_HTTP: request is unauthorized!');
                        if (error.url.indexOf('/authorize') === -1) {
                            // auth error handling, observing for authorization
                            return new Rx_1.Observable(function (observer) {
                                if (error.headers.get('WWW-Authenticate') !== null) {
                                    // requesting authorization to KC server
                                    _this.keycloakAuth
                                        .authorize(error.headers.get('WWW-Authenticate'))
                                        .subscribe(function (token) {
                                        // notifying observers for authz result token
                                        observer.next(token);
                                    });
                                }
                                else {
                                    // console.warn('WWW-Authenticate header not found' + error.headers.get('WWW-Authenticate'));
                                }
                            });
                        }
                        else {
                            return Rx_1.Observable.throw(error.status);
                        }
                    }
                    else {
                        return Rx_1.Observable.throw(error.status);
                    }
                });
            })
                .flatMap(function (res) {
                // Http Response or Authz token
                if (res instanceof http_1.Response) {
                    // Http response
                    return new Rx_1.Observable(function (observer) {
                        return observer.next(res);
                    });
                }
                else {
                    // Authorization token
                    _this.keycloak.accessToken = res;
                    count = count + 1;
                    // retrying request with new token
                    // console.info('KC_HTTP: retrying request with new authorization token');
                    return _this.configureRequest(url, count, options);
                }
            });
        }
    };
    // to add 'Authorization' header
    KeycloakHttp.prototype.setHeaders = function (options) {
        var _this = this;
        return new Rx_1.Observable(function (observer) {
            if (options && options.withCredentials) {
                // console.info('adding headers with options ' + options);
                var token_1 = _this.keycloak.accessToken;
                if (_this.keycloak.refreshToken) {
                    // console.info('checking token');
                    _this.keycloak.updateToken(5).subscribe(function (res) {
                        token_1 = res;
                        if (!options.headers) {
                            options.headers = new http_1.Headers();
                        }
                        // console.info('returning an updated token');
                        options.headers.set('Authorization', 'Bearer ' + token_1);
                        observer.next(options);
                    });
                }
                else {
                    if (!options.headers) {
                        options.headers = new http_1.Headers();
                    }
                    // console.info('returning the existing token ');
                    options.headers.set('Authorization', 'Bearer ' + token_1);
                    observer.next(options);
                }
            }
            else {
                observer.next(options);
            }
        });
    };
    // Observable on service status.
    // If true, keycloakHttp is ready to handle requests
    KeycloakHttp.readyBehaviourSubject = new Rx_1.BehaviorSubject(false);
    KeycloakHttp.readyObs = KeycloakHttp_1.readyBehaviourSubject.asObservable();
    KeycloakHttp = KeycloakHttp_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.ConnectionBackend,
            http_1.RequestOptions,
            keycloak_auth_service_1.KeycloakAuthorization,
            keycloak_core_service_1.Keycloak])
    ], KeycloakHttp);
    return KeycloakHttp;
    var KeycloakHttp_1;
}(http_1.Http));
exports.KeycloakHttp = KeycloakHttp;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(18));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(6);
var http_1 = __webpack_require__(2);
var keycloak_core_service_1 = __webpack_require__(1);
var keycloak_auth_service_1 = __webpack_require__(5);
var keycloak_http_service_1 = __webpack_require__(16);
var keycloak_storage_ionic_1 = __webpack_require__(15);
__export(__webpack_require__(8));
__export(__webpack_require__(7));
__export(__webpack_require__(5));
__export(__webpack_require__(1));
__export(__webpack_require__(16));
__export(__webpack_require__(10));
__export(__webpack_require__(9));
__export(__webpack_require__(12));
__export(__webpack_require__(14));
__export(__webpack_require__(13));
__export(__webpack_require__(11));
function keycloakHttpFactory(backend, defaultOptions, auth, keycloak) {
    return new keycloak_http_service_1.KeycloakHttp(backend, defaultOptions, auth, keycloak);
}
exports.keycloakHttpFactory = keycloakHttpFactory;
var KeycloakModule = (function () {
    function KeycloakModule() {
    }
    KeycloakModule_1 = KeycloakModule;
    KeycloakModule.forRoot = function () {
        return {
            ngModule: KeycloakModule_1,
            providers: [
                keycloak_core_service_1.Keycloak,
                keycloak_auth_service_1.KeycloakAuthorization,
                keycloak_http_service_1.KeycloakHttp,
                keycloak_storage_ionic_1.IonicStorage,
                {
                    provide: http_1.Http,
                    useFactory: keycloakHttpFactory,
                    deps: [http_1.XHRBackend, http_1.RequestOptions, keycloak_auth_service_1.KeycloakAuthorization, keycloak_core_service_1.Keycloak]
                }
            ]
        };
    };
    KeycloakModule = KeycloakModule_1 = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule]
        })
    ], KeycloakModule);
    return KeycloakModule;
    var KeycloakModule_1;
}());
exports.KeycloakModule = KeycloakModule;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UUID = (function () {
    function UUID() {
        // no-op
    }
    UUID.UUID = function () {
        if (typeof (window) !== "undefined" && typeof (window.crypto) !== "undefined" && typeof (window.crypto.getRandomValues) !== "undefined") {
            // If we have a cryptographically secure PRNG, use that
            // http://stackoverflow.com/questions/6906916/collisions-when-generating-uuids-in-javascript
            var buf = new Uint16Array(8);
            window.crypto.getRandomValues(buf);
            return (this.pad4(buf[0]) + this.pad4(buf[1]) + "-" + this.pad4(buf[2]) + "-" + this.pad4(buf[3]) + "-" + this.pad4(buf[4]) + "-" + this.pad4(buf[5]) + this.pad4(buf[6]) + this.pad4(buf[7]));
        }
        else {
            // Otherwise, just use Math.random
            // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
            // https://stackoverflow.com/questions/11605068/why-does-jshint-argue-against-bitwise-operators-how-should-i-express-this-code
            return this.random4() + this.random4() + "-" + this.random4() + "-" + this.random4() + "-" +
                this.random4() + "-" + this.random4() + this.random4() + this.random4();
        }
    };
    UUID.pad4 = function (num) {
        var ret = num.toString(16);
        while (ret.length < 4) {
            ret = "0" + ret;
        }
        return ret;
    };
    UUID.random4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return UUID;
}());
exports.UUID = UUID;
//# sourceMappingURL=index.js.map

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"root":["ng","core"],"commonjs":"@angular/core","commonjs2":"@angular/core","amd":"@angular/core"}
var core__ = __webpack_require__(0);
var core___default = /*#__PURE__*/__webpack_require__.n(core__);

// EXTERNAL MODULE: ./node_modules/localforage/dist/localforage.js
var localforage = __webpack_require__(21);
var localforage_default = /*#__PURE__*/__webpack_require__.n(localforage);

// EXTERNAL MODULE: ./node_modules/localforage-cordovasqlitedriver/dist/localforage-cordovasqlitedriver.js
var localforage_cordovasqlitedriver = __webpack_require__(23);
var localforage_cordovasqlitedriver_default = /*#__PURE__*/__webpack_require__.n(localforage_cordovasqlitedriver);

// CONCATENATED MODULE: ./node_modules/@ionic/storage/dist/storage.js



/**
 * Storage is an easy way to store key/value pairs and JSON objects.
 * Storage uses a variety of storage engines underneath, picking the best one available
 * depending on the platform.
 *
 * When running in a native app context, Storage will prioritize using SQLite, as it's one of
 * the most stable and widely used file-based databases, and avoids some of the
 * pitfalls of things like localstorage and IndexedDB, such as the OS deciding to clear out such
 * data in low disk-space situations.
 *
 * When running in the web or as a Progressive Web App, Storage will attempt to use
 * IndexedDB, WebSQL, and localstorage, in that order.
 *
 * @usage
 * First, if you'd like to use SQLite, install the cordova-sqlite-storage plugin:
 * ```bash
 * ionic cordova plugin add cordova-sqlite-storage
 * ```
 *
 * Next, install the package (comes by default for Ionic apps > Ionic V1):
 * ```bash
 * npm install --save @ionic/storage
 * ```
 *
 * Next, add it to the imports list in your `NgModule` declaration (for example, in `src/app/app.module.ts`):
 *
 * ```typescript
 * import { IonicStorageModule } from '@ionic/storage';
 *
 * @NgModule({
 *   declarations: [
 *     // ...
 *   ],
 *   imports: [
 *     BrowserModule,
 *     IonicModule.forRoot(MyApp),
 *     IonicStorageModule.forRoot()
 *   ],
 *   bootstrap: [IonicApp],
 *   entryComponents: [
 *     // ...
 *   ],
 *   providers: [
 *     // ...
 *   ]
 * })
 * export class AppModule {}
 *```
 *
 * Finally, inject it into any of your components or pages:
 * ```typescript
 * import { Storage } from '@ionic/storage';

 * export class MyApp {
 *   constructor(private storage: Storage) { }
 *
 *   ...
 *
 *   // set a key/value
 *   storage.set('name', 'Max');
 *
 *   // Or to get a key/value pair
 *   storage.get('age').then((val) => {
 *     console.log('Your age is', val);
 *   });
 * }
 * ```
 *
 *
 * ### Configuring Storage
 *
 * The Storage engine can be configured both with specific storage engine priorities, or custom configuration
 * options to pass to localForage. See the localForage config docs for possible options: https://github.com/localForage/localForage#configuration
 *
 * Note: Any custom configurations will be merged with the default configuration
 *
 * ```typescript
 * import { IonicStorageModule } from '@ionic/storage';
 *
 * @NgModule({
 *   declarations: [...],
 *   imports: [
 *     IonicStorageModule.forRoot({
 *       name: '__mydb',
         driverOrder: ['indexeddb', 'sqlite', 'websql']
 *     })
 *   ],
 *   bootstrap: [...],
 *   entryComponents: [...],
 *    providers: [...]
 * })
 * export class AppModule { }
 * ```
 */
var storage_Storage = (function () {
    /**
     * Create a new Storage instance using the order of drivers and any additional config
     * options to pass to LocalForage.
     *
     * Possible driver options are: ['sqlite', 'indexeddb', 'websql', 'localstorage'] and the
     * default is that exact ordering.
     */
    function Storage(config) {
        var _this = this;
        this._driver = null;
        this._dbPromise = new Promise(function (resolve, reject) {
            var db;
            var defaultConfig = getDefaultConfig();
            var actualConfig = Object.assign(defaultConfig, config || {});
            localforage_default.a.defineDriver(localforage_cordovasqlitedriver_default.a).then(function () {
                db = localforage_default.a.createInstance(actualConfig);
            })
                .then(function () { return db.setDriver(_this._getDriverOrder(actualConfig.driverOrder)); })
                .then(function () {
                _this._driver = db.driver();
                resolve(db);
            })
                .catch(function (reason) { return reject(reason); });
        });
    }
    Object.defineProperty(Storage.prototype, "driver", {
        /**
         * Get the name of the driver being used.
         * @returns {string | null} Name of the driver
         */
        get: function () {
            return this._driver;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Reflect the readiness of the store.
     * @returns {Promise<LocalForage>} Returns a promise that resolves when the store is ready
     */
    Storage.prototype.ready = function () {
        return this._dbPromise;
    };
    Storage.prototype._getDriverOrder = function (driverOrder) {
        return driverOrder.map(function (driver) {
            switch (driver) {
                case 'sqlite':
                    return localforage_cordovasqlitedriver_default.a._driver;
                case 'indexeddb':
                    return localforage_default.a.INDEXEDDB;
                case 'websql':
                    return localforage_default.a.WEBSQL;
                case 'localstorage':
                    return localforage_default.a.LOCALSTORAGE;
            }
        });
    };
    /**
     * Get the value associated with the given key.
     * @param {any} key the key to identify this value
     * @returns {Promise} Returns a promise with the value of the given key
     */
    Storage.prototype.get = function (key) {
        return this._dbPromise.then(function (db) { return db.getItem(key); });
    };
    /**
     * Set the value for the given key.
     * @param {any} key the key to identify this value
     * @param {any} value the value for this key
     * @returns {Promise} Returns a promise that resolves when the key and value are set
     */
    Storage.prototype.set = function (key, value) {
        return this._dbPromise.then(function (db) { return db.setItem(key, value); });
    };
    /**
     * Remove any value associated with this key.
     * @param {any} key the key to identify this value
     * @returns {Promise} Returns a promise that resolves when the value is removed
     */
    Storage.prototype.remove = function (key) {
        return this._dbPromise.then(function (db) { return db.removeItem(key); });
    };
    /**
     * Clear the entire key value store. WARNING: HOT!
     * @returns {Promise} Returns a promise that resolves when the store is cleared
     */
    Storage.prototype.clear = function () {
        return this._dbPromise.then(function (db) { return db.clear(); });
    };
    /**
     * @returns {Promise} Returns a promise that resolves with the number of keys stored.
     */
    Storage.prototype.length = function () {
        return this._dbPromise.then(function (db) { return db.length(); });
    };
    /**
     * @returns {Promise} Returns a promise that resolves with the keys in the store.
     */
    Storage.prototype.keys = function () {
        return this._dbPromise.then(function (db) { return db.keys(); });
    };
    /**
     * Iterate through each key,value pair.
     * @param {any} iteratorCallback a callback of the form (value, key, iterationNumber)
     * @returns {Promise} Returns a promise that resolves when the iteration has finished.
     */
    Storage.prototype.forEach = function (iteratorCallback) {
        return this._dbPromise.then(function (db) { return db.iterate(iteratorCallback); });
    };
    return Storage;
}());

/** @hidden */
function getDefaultConfig() {
    return {
        name: '_ionicstorage',
        storeName: '_ionickv',
        driverOrder: ['sqlite', 'indexeddb', 'websql', 'localstorage']
    };
}
;
/** @hidden */
var StorageConfigToken = new core__["InjectionToken"]('STORAGE_CONFIG_TOKEN');
/** @hidden */
function provideStorage(storageConfig) {
    var config = !!storageConfig ? storageConfig : getDefaultConfig();
    return new storage_Storage(config);
}

// CONCATENATED MODULE: ./node_modules/@ionic/storage/dist/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IonicStorageModule", function() { return dist_IonicStorageModule; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StorageConfigToken", function() { return StorageConfigToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Storage", function() { return storage_Storage; });



var dist_IonicStorageModule = (function () {
    function IonicStorageModule() {
    }
    IonicStorageModule.forRoot = function (storageConfig) {
        if (storageConfig === void 0) { storageConfig = null; }
        return {
            ngModule: IonicStorageModule,
            providers: [
                { provide: StorageConfigToken, useValue: storageConfig },
                { provide: storage_Storage, useFactory: provideStorage, deps: [StorageConfigToken] },
            ]
        };
    };
    IonicStorageModule.decorators = [
        { type: core__["NgModule"], args: [{},] },
    ];
    /** @nocollapse */
    IonicStorageModule.ctorParameters = function () { return []; };
    return IonicStorageModule;
}());



/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.4.3
    https://mozilla.github.io/localForage
    (c) 2013-2016 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(2);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && typeof obj === 'object' && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

exports.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

exports.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

exports.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

exports.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"2":2}],2:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(1);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"1":1}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {}
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here; just UA test for Safari (which, as of
        // iOS 8/Yosemite, doesn't properly support IndexedDB).
        // IndexedDB support is broken and different from Blink's.
        // This is faster than the test case (and it's sync), so we just
        // do this. *SIGH*
        // http://bl.ocks.org/nolanlawson/raw/c83e9039edf2278047e9/
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        if (typeof openDatabase !== 'undefined' && typeof navigator !== 'undefined' && navigator.userAgent && /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
            return false;
        }

        return idb && typeof idb.open === 'function' &&
        // Some Samsung/HTC Android 4.0-4.3 devices
        // have older IndexedDB specs; if this isn't available
        // their IndexedDB is too old for us to use.
        // (Replaces the onupgradeneeded test.)
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage && localStorage.setItem;
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined' && typeof _dereq_ !== 'undefined') {
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs;
var dbContexts;
var toString = Object.prototype.toString;

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/9c25a23/src/adapters/idb/blobSupport.js
//
function _checkBlobSupportWithoutCaching(txn) {
    return new Promise$1(function (resolve) {
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve) {
        deferredOperation.resolve = resolve;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function () {
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + ' can\'t be downgraded from version ' + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Initialize a singleton container for all running localForages.
    if (!dbContexts) {
        dbContexts = {};
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = {
            // Running localForages sharing a database.
            forages: [],
            // Shared database.
            db: null,
            // Database readiness (promise).
            dbReady: null,
            // Deferred operations on the database.
            deferredOperations: []
        };
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);
            var req = store.get(key);

            req.onsuccess = function () {
                var value = req.result;
                if (value === undefined) {
                    value = null;
                }
                if (_isEncodedBlob(value)) {
                    value = _decodeBlob(value);
                }
                resolve(value);
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

            var req = store.openCursor();
            var iterationNumber = 1;

            req.onsuccess = function () {
                var cursor = req.result;

                if (cursor) {
                    var value = cursor.value;
                    if (_isEncodedBlob(value)) {
                        value = _decodeBlob(value);
                    }
                    var result = iterator(value, cursor.key, iterationNumber++);

                    if (result !== void 0) {
                        resolve(result);
                    } else {
                        cursor["continue"]();
                    }
                } else {
                    resolve();
                }
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
            var store = transaction.objectStore(dbInfo.storeName);

            // The reason we don't _save_ null is because IE 10 does
            // not support saving the `null` type in IndexedDB. How
            // ironic, given the bug below!
            // See: https://github.com/mozilla/localForage/issues/161
            if (value === null) {
                value = undefined;
            }

            transaction.oncomplete = function () {
                // Cast to undefined so the value passed to
                // callback/promise is the same as what one would get out
                // of `getItem()` later. This leads to some weirdness
                // (setItem('foo', undefined) will return `null`), but
                // it's not my fault localStorage is our baseline and that
                // it's weird.
                if (value === undefined) {
                    value = null;
                }

                resolve(value);
            };
            transaction.onabort = transaction.onerror = function () {
                var err = req.error ? req.error : req.transaction.error;
                reject(err);
            };

            var req = store.put(value, key);
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
            var store = transaction.objectStore(dbInfo.storeName);

            // We use a Grunt task to make this safe for IE and some
            // versions of Android (including those used by Cordova).
            // Normally IE won't like `.delete()` and will insist on
            // using `['delete']()`, but we have a build step that
            // fixes this for us now.
            var req = store["delete"](key);
            transaction.oncomplete = function () {
                resolve();
            };

            transaction.onerror = function () {
                reject(req.error);
            };

            // The request will be also be aborted if we've exceeded our storage
            // space.
            transaction.onabort = function () {
                var err = req.error ? req.error : req.transaction.error;
                reject(err);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var transaction = dbInfo.db.transaction(dbInfo.storeName, 'readwrite');
            var store = transaction.objectStore(dbInfo.storeName);
            var req = store.clear();

            transaction.oncomplete = function () {
                resolve();
            };

            transaction.onabort = transaction.onerror = function () {
                var err = req.error ? req.error : req.transaction.error;
                reject(err);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);
            var req = store.count();

            req.onsuccess = function () {
                resolve(req.result);
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

            var advanced = false;
            var req = store.openCursor();
            req.onsuccess = function () {
                var cursor = req.result;
                if (!cursor) {
                    // this means there weren't enough keys
                    resolve(null);

                    return;
                }

                if (n === 0) {
                    // We have the first key, return it if that's what they
                    // wanted.
                    resolve(cursor.key);
                } else {
                    if (!advanced) {
                        // Otherwise, ask the cursor to skip ahead n
                        // records.
                        advanced = true;
                        cursor.advance(n);
                    } else {
                        // When we get here, we've got the nth key.
                        resolve(cursor.key);
                    }
                }
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            var store = dbInfo.db.transaction(dbInfo.storeName, 'readonly').objectStore(dbInfo.storeName);

            var req = store.openCursor();
            var keys = [];

            req.onsuccess = function () {
                var cursor = req.result;

                if (!cursor) {
                    resolve(keys);
                    return;
                }

                keys.push(cursor.key);
                cursor["continue"]();
            };

            req.onerror = function () {
                reject(req.error);
            };
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys
};

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' (id INTEGER PRIMARY KEY, key unique, value)', [], function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        });
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function getItem$1(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        t.executeSql('INSERT OR REPLACE INTO ' + dbInfo.storeName + ' (key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // TODO: Try to re-run the transaction.
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem$1(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                t.executeSql('SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;

                    resolve(result);
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                t.executeSql('SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {

                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1
};

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = dbInfo.name + '/';

    if (dbInfo.storeName !== self._defaultConfig.storeName) {
        dbInfo.keyPrefix += dbInfo.storeName + '/';
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            if (localStorage.key(i).indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(localStorage.key(i).substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    // Default API, from Gaia/localStorage.
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2
};

// Custom drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var CustomDrivers = {};

var DriverType = {
    INDEXEDDB: 'asyncStorage',
    LOCALSTORAGE: 'localStorageWrapper',
    WEBSQL: 'webSQLStorage'
};

var DefaultDriverOrder = [DriverType.INDEXEDDB, DriverType.WEBSQL, DriverType.LOCALSTORAGE];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'];

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

var driverSupport = {};
// Check to see if IndexedDB is available and if it is the latest
// implementation; it's our preferred backend library. We use "_spec_test"
// as the name of the database because it's not the one we'll operate on,
// but it's useful to make sure its using the right spec.
// See: https://github.com/mozilla/localForage/issues/128
driverSupport[DriverType.INDEXEDDB] = isIndexedDBValid();

driverSupport[DriverType.WEBSQL] = isWebSQLValid();

driverSupport[DriverType.LOCALSTORAGE] = isLocalStorageValid();

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var key in arg) {
                if (arg.hasOwnProperty(key)) {
                    if (isArray(arg[key])) {
                        arguments[0][key] = arg[key].slice();
                    } else {
                        arguments[0][key] = arg[key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

function isLibraryDriver(driverName) {
    for (var driver in DriverType) {
        if (DriverType.hasOwnProperty(driver) && DriverType[driver] === driverName) {
            return true;
        }
    }

    return false;
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        this.INDEXEDDB = DriverType.INDEXEDDB;
        this.LOCALSTORAGE = DriverType.LOCALSTORAGE;
        this.WEBSQL = DriverType.WEBSQL;

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver);
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');
                var namingError = new Error('Custom driver name already in use: ' + driverObject._driver);

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }
                if (isLibraryDriver(driverObject._driver)) {
                    reject(namingError);
                    return;
                }

                var customDriverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0; i < customDriverMethods.length; i++) {
                    var customDriverMethod = customDriverMethods[i];
                    if (!customDriverMethod || !driverObject[customDriverMethod] || typeof driverObject[customDriverMethod] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var supportPromise = Promise$1.resolve(true);
                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        supportPromise = driverObject._support();
                    } else {
                        supportPromise = Promise$1.resolve(!!driverObject._support);
                    }
                }

                supportPromise.then(function (supportResult) {
                    driverSupport[driverName] = supportResult;
                    CustomDrivers[driverName] = driverObject;
                    resolve();
                }, reject);
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var self = this;
        var getDriverPromise = Promise$1.resolve().then(function () {
            if (isLibraryDriver(driverName)) {
                switch (driverName) {
                    case self.INDEXEDDB:
                        return asyncStorage;
                    case self.LOCALSTORAGE:
                        return localStorageWrapper;
                    case self.WEBSQL:
                        return webSQLStorage;
                }
            } else if (CustomDrivers[driverName]) {
                return CustomDrivers[driverName];
            } else {
                throw new Error('Driver not found.');
            }
        });
        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(function (driver) {
                            self._extend(driver);
                            setDriverToConfig();

                            self._ready = self._initStorage(self._config);
                            return self._ready;
                        })["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!driverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0; i < LibraryMethods.length; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.cordovaSQLiteDriver = factory());
}(this, function () { 'use strict';

    function getSerializerPromise(localForageInstance) {
        if (getSerializerPromise.result) {
            return getSerializerPromise.result;
        }
        if (!localForageInstance || typeof localForageInstance.getSerializer !== 'function') {
            return Promise.reject(new Error('localforage.getSerializer() was not available! ' + 'localforage v1.4+ is required!'));
        }
        getSerializerPromise.result = localForageInstance.getSerializer();
        return getSerializerPromise.result;
    }

    function getDriverPromise(localForageInstance, driverName) {
        getDriverPromise.result = getDriverPromise.result || {};
        if (getDriverPromise.result[driverName]) {
            return getDriverPromise.result[driverName];
        }
        if (!localForageInstance || typeof localForageInstance.getDriver !== 'function') {
            return Promise.reject(new Error('localforage.getDriver() was not available! ' + 'localforage v1.4+ is required!'));
        }
        getDriverPromise.result[driverName] = localForageInstance.getDriver(driverName);
        return getDriverPromise.result[driverName];
    }

    function getWebSqlDriverPromise(localForageInstance) {
        return getDriverPromise(localForageInstance, localForageInstance.WEBSQL);
    }

    /* global document, sqlitePlugin */
    // we can't import this, since it gets defined later
    // import sqlitePlugin from 'sqlitePlugin';

    var deviceReady = new Promise(function (resolve, reject) {
        if (typeof sqlitePlugin !== 'undefined') {
            resolve();
        } else if (typeof cordova === 'undefined') {
            reject(new Error('cordova is not defined.'));
        } else {
            // Wait for Cordova to load
            document.addEventListener("deviceready", function () {
                return resolve();
            }, false);
        }
    });

    var deviceReadyDone = deviceReady.catch(function () {
        return Promise.resolve();
    });

    function getOpenDatabasePromise() {
        return deviceReadyDone.then(function () {
            if (typeof sqlitePlugin !== 'undefined' && typeof sqlitePlugin.openDatabase === 'function') {
                return sqlitePlugin.openDatabase;
            } else {
                throw new Error('SQLite plugin is not present.');
            }
        });
    }

    // // If cordova is not present, we can stop now.
    // if (!globalObject.cordova) {
    //     return;
    // }

    // Open the cordova sqlite plugin database (automatically creates one if one didn't
    // previously exist), using any options set in the config.
    function _initStorage(options) {
        var self = this;
        var dbInfo = {
            db: null
        };

        if (options) {
            for (var i in options) {
                dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
            }
        }

        var dbInfoPromise = getOpenDatabasePromise().then(function (openDatabase) {
            return new Promise(function (resolve, reject) {
                // Open the database; the openDatabase API will automatically
                // create it for us if it doesn't exist.
                try {
                    dbInfo.location = dbInfo.location || 'default';
                    dbInfo.db = openDatabase({
                        name: dbInfo.name,
                        version: String(dbInfo.version),
                        description: dbInfo.description,
                        size: dbInfo.size,
                        location: dbInfo.location
                    });
                } catch (e) {
                    reject(e);
                }

                // Create our key/value table if it doesn't exist.
                dbInfo.db.transaction(function (t) {
                    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' (id INTEGER PRIMARY KEY, key unique, value)', [], function () {
                        self._dbInfo = dbInfo;
                        resolve();
                    }, function (t, error) {
                        reject(error);
                    });
                });
            });
        });

        var serializerPromise = getSerializerPromise(self);
        var webSqlDriverPromise = getWebSqlDriverPromise(self);

        return Promise.all([serializerPromise, webSqlDriverPromise, dbInfoPromise]).then(function (results) {
            dbInfo.serializer = results[0];
            return dbInfoPromise;
        });
    }

    var cordovaSQLiteDriver = {
        _driver: 'cordovaSQLiteDriver',
        _initStorage: _initStorage,
        _support: function _support() {
            return getOpenDatabasePromise().then(function (openDatabase) {
                return !!openDatabase;
            }).catch(function () {
                return false;
            });
        }
    };

    function wireUpDriverMethods(driver) {
        var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'];

        function wireUpDriverMethod(driver, methodName) {
            driver[methodName] = function () {
                var localForageInstance = this;
                var args = arguments;
                return getWebSqlDriverPromise(localForageInstance).then(function (webSqlDriver) {
                    return webSqlDriver[methodName].apply(localForageInstance, args);
                });
            };
        }

        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            wireUpDriverMethod(driver, LibraryMethods[i]);
        }
    }

    wireUpDriverMethods(cordovaSQLiteDriver);

    return cordovaSQLiteDriver;

}));

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ngx-keycloak.umd.min.js